"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const video_client_core_1 = require("@video/video-client-core");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const CarouselSlideWrapper_1 = tslib_1.__importDefault(require("../../../ui-lib/Carousel/CarouselSlideWrapper"));
const ModularCarouselSlideWrapper = (0, mobx_react_lite_1.observer)(({ classes, children, publicKey }) => {
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<CarouselSlideWrapper/>");
    const handleOnClick = () => {
        if (video_client_core_1.adapter.device.isMobileDevice && publicKey != null) {
            ctx.startPlayer(publicKey);
        }
    };
    const handleOnKeyDown = (e) => {
        if (video_client_core_1.adapter.device.isMobileDevice && e.key === "Enter" && publicKey != null) {
            ctx.startPlayer(publicKey);
        }
    };
    return (react_1.default.createElement(CarouselSlideWrapper_1.default, { classes: classes, onClick: handleOnClick, onKeydown: handleOnKeyDown }, children));
});
/**
 *
 * @visibleName Carousel Slide Wrapper
 */
// eslint-disable-next-line react/function-component-definition
const CarouselSlideWrapperWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(CarouselSlideWrapper_1.default, { classes: classes, onClick: undefined, onKeydown: undefined, ...props }) },
        react_1.default.createElement(ModularCarouselSlideWrapper, { classes: classes, ...props })));
};
exports.default = CarouselSlideWrapperWithErrorBoundary;
//# sourceMappingURL=MultistreamCarouselSlideWrapper.js.map